import ApiService from './api.service'
import { StorageService } from './storage.service'

class ExtensibleSMSError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const ExtensibleSMSService = {
    BASE_URL: process.env.VUE_APP_EXT_URL,
    /**
     * Fetch current user's extensible sms.
     *
     * @returns Extensible SMS List
     * @throws ExtensibleSMSError
    **/
    fetchAll: async function(data) {
        try {
            const response = await ApiService.get(`${this.BASE_URL}/list?uuid=${data.uuid}&type=${data.type}`, data)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Fetch media types.
     *
     * @returns Media Types
     * @throws ExtensibleSMSError
    **/
    mediaTypeFetchAll: async function(data) {
        try {
            const response = await ApiService.post(this.BASE_URL+"/media-item", data);
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Soft Deletes an Ex-SMS.
     *
     * @returns Ex-SMS
     * @throws ExtensibleSMSError
    **/
    extensibleSmsSoftDelete: async function(data) {
        try {
            const response = await ApiService.post(this.BASE_URL+"/delete", data)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Adds new Extensible SMS to database.
     *
     * @returns Ex-SMS
     * @throws ExtensibleSMSError
    **/
    createExtensibleSms: async function(data) {
        try {
            const response = await ApiService.post(this.BASE_URL+"/create", data)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Adds new Extensible SMS to database.
     *
     * @returns Ex-SMS
     * @throws ExtensibleSMSError
    **/
    createQuestionnaire: async function(data) {
        try {
            const response = await ApiService.post(this.BASE_URL+"/questionnaire", data)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Delete Extensible SMS from database.
     *
     * @returns Ex-SMS
     * @throws ExtensibleSMSError
    **/
    delete: async function(data) {
        try {
            const response = await ApiService.delete(`${this.BASE_URL}/delete/${data.id}?type=${data.type}&uuid=${data.uuid}`)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Fetch extensible sms reviews.
     *
     * @returns Extensible SMS Reviews
     * @throws ExtensibleSMSError
    **/
    fetchReviews: async function(id) {
        try {
            const response = await ApiService.get(`${this.BASE_URL}/${id}/reviews`)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },

    /**
     * Reload questionnaire.
     *
     * @returns Extensible SMS Questionnaire
     * @throws ExtensibleSMSError
    **/
    reloadQuestionnaire: async function(id, uuid) {
        try {
            const response = await ApiService.get(`${this.BASE_URL}/${id}/questionnaire?uuid=${uuid}`)
            return response.data
        } catch (error) {
            throw new ExtensibleSMSError(error.response.status, error.response.data.detail)
        }
    },
}

export { ExtensibleSMSService, ExtensibleSMSError }